import Model from '@/models/Model.js';

export default class SlideDeck extends Model {
    static entity = 'slide_decks';

    static modelName = 'SlideDeck';

    static fields() {
        return {
            id: this.attr(null),
            description: this.attr(null),
            reference_id: this.attr(null),
            slide_deck_urls: this.attr(null),
            slide_deck_cookies: this.attr(null),
            thumbnail_signed_url: this.attr(null),
            total_slides: this.attr(null),
            title: this.attr(null),
            slide_deck: this.attr(null),
            processed_by: this.attr(null),
            processed_at: this.attr(null),
            image_size: this.attr(null),
            aspect_ratio: this.attr(null),
            output_extension: this.attr(null),
            has_pdf: this.attr(null),

            ...super.fields(),

            tags: this.morphToMany('tags', 'taggables', 'tag_id', 'taggable_id', 'taggable_type'),
            groups: this.belongsToMany('groups', 'slide_deck_group', 'slide_deck_id', 'group_id'),
            statuses: this.morphMany('statuses', 'model_id', 'model_type_entity'),
        };
    }
}
